import React from "react";
import MuteButton from "./MuteButton";
import CameraButton from "./CameraButton";
import HangUpButton from "./HangUpButton";
import ShareScreenButton from "./ShareScreenButton";
import SettingsButton from "./SettingsButton";

interface ControlsPanelProps {
  muted: boolean;
  onToggleMute: () => void;
  cameraOn: boolean;
  onToggleCamera: () => void;
  hangUp: () => void;
  shared: boolean;
  onShareScreen: () => void;
  messagesOpen: boolean;
  onToggleMesages: () => void;
  settingsOpen: boolean;
  onToggleSettings: () => void;
}

const ControlsPanel: React.FC<ControlsPanelProps> = ({
  muted,
  onToggleMute,
  cameraOn,
  onToggleCamera,
  hangUp,
  shared,
  onShareScreen,
  settingsOpen,
  onToggleSettings,
}) => {
  return (
    <div className="d-flex align-items-center justify-content-center">
      {" "}
      {/* Updated for centering by parent */}
      <div className="d-flex overflow-hidden p-2 gap-3">
        {" "}
        {/* Changed bg-gray-800 to bg-secondary and added p-2 */}
        <MuteButton muted={muted} onToggle={onToggleMute} />
        <CameraButton isOn={cameraOn} onClick={onToggleCamera} />
        <ShareScreenButton shared={shared} onToggle={onShareScreen} />
        {/* <MessagesButton isOn={messagesOpen} onClick={onToggleMesages}/> */}
        <SettingsButton isOn={settingsOpen} onClick={onToggleSettings} />
        <div className="py-1">
          <div className="bg-[#8D8D8D] h-full" style={{ width: "0.125rem" }}></div>
        </div>
        <HangUpButton onClick={hangUp} />
      </div>
      <div className="overflow-hidden ms-3">
        {" "}
        {/* Added ms-3 for spacing and changed to rounded-pill */}
      </div>
    </div>
  );
};

export default ControlsPanel;
